export interface UpsellContent {
  inclusions: string[];
  exclusions: string[];
}

export const INCLUSION_EXCLUSIONS_COPY = {
  AD_PAY_MONTHLY: {
    inclusions: [
      'Immediate protection of your product from accidental damage (including TV screen burn)',
      'Breakdown cover after the end of the manufacturer’s guarantee period',
      'Unlimited repairs on your product (including parts and labour), with no excess to pay',
      'A replacement product (for example where we cannot repair it or we decide that it is uneconomical for us to repair your product',
      'Delivery of your replacement product',
      'Replacement TV installation',
    ],
    exclusions: [
      'Costs arising from not being able to use your product or damage to other property',
      'Loss (including stored information), cosmetic damage, neglect or deliberate damage',
      'Costs for replacing any accessories (other than those provided with your product), disposal and set up',
      'A software virus or a software based malfunction',
      'Enhanced wall mount service for TV installation',
    ],
  },
  WHITE_GOODS_PAY_MONTHLY: {
    inclusions: [
      'Immediate protection of your product from accidental damage',
      'Breakdown cover after the end of the manufacturer’s guarantee period',
      'Unlimited repairs on your product (including call-outs, parts and labour), with no excess to pay',
      'A replacement product (for example where we cannot repair it or we decide that it is uneconomical for us to repair your product)',
      'A gift card for the full retail price of a replacement (if we cannot reasonably arrange a replacement)',
      'Set up and support services via telephone and online, to ensure your product continues to function properly',
      'Contribution benefit of up to £50 for ancillary costs incurred by you such as for food or use of launderette, from the point your product suffers breakdown or accidental damage until your claim is resolved',
      '£25 as our first time fix promise in the event that a repair carried out is not completed by the end of the day of the first visit',
    ],
    exclusions: [
      'Costs arising from not being able to use your product or damage to other property loss, cosmetic damage, neglect or deliberate damage',
      'Costs for replacing any accessories and for the disposal of your original product',
    ],
  },
  MOBILE_PAY_MONTHLY: {
    inclusions: [
      'Immediate protection of your product from accidental damage (including TV screen burn)',
      'Breakdown cover after the end of the manufacturer’s guarantee period',
      'Unlimited repairs on your product (including parts and labour), with no excess to pay',
      'A replacement product (for example where we cannot repair it or we decide that it is uneconomical for us to repair your product',
      'A gift card for the full retail price of a replacement (if we cannot reasonably arrange a replacement)',
      'The cost of replacing accessories originally purchased and provided with your product',
      'Delivery of your replacement product',
    ],
    exclusions: [
      'Costs arising from not being able to use your product or damage to other property',
      'Loss (including stored information), cosmetic damage, neglect or deliberate damage',
      'Costs for replacing any accessories (other than those provided with your product), disposal and set up',
      'A software virus or a software based malfunction',
    ],
  },
  DEFAULT: {
    inclusions: [
      'Repairs by expert engineers using genuine parts',
      'Parts, labour, and call-out charges',
      'Immediate accidental damage cover',
      'Unlimited repairs with no surprise or hidden costs',
      'A brand-new replacement if your model can’t be fixed',
      'Breakdowns after your manufacturer’s guarantee has ended',
    ],
    exclusions: [
      'Cosmetic and malicious damage',
      'Costs that you may incur as a result of not being able to use your product',
      'Installation and recycle charges for replacement appliance',
    ],
  },
};

export class AddProtectionHelper {
  upsellInclusionsExclusionsCopy(scheme: string): UpsellContent {
    switch (scheme) {
      // AD (pay monthly)
      case 'YU':
      case 'YV6':
      case 'YV7':
        return INCLUSION_EXCLUSIONS_COPY.AD_PAY_MONTHLY;
      // White (pay monthly)
      case 'YV4':
      case 'YV5':
        return INCLUSION_EXCLUSIONS_COPY.WHITE_GOODS_PAY_MONTHLY;
      // Mobile (pay monthly)
      case 'YU8':
      case 'YU2':
      case 'YU3':
        return INCLUSION_EXCLUSIONS_COPY.MOBILE_PAY_MONTHLY;
      default:
        return INCLUSION_EXCLUSIONS_COPY.DEFAULT;
    }
  }
}
